
/**
 * 用户邮箱认证状态
 *
 * // 认证中
 * UNDER_CERTIFICATION
 *
 * // 认证成功
 * AUTHENTICATION_SUCCESSFUL
 *
 * // 已认证
 * CERTIFIED
 *
 */
export const emailAuthStatus = {
    // 认证中
    UNDER_CERTIFICATION: "UNDER_CERTIFICATION",
    // 认证成功
    AUTHENTICATION_SUCCESSFUL: "AUTHENTICATION_SUCCESSFUL",
    // 已认证
    CERTIFIED: "CERTIFIED"
}

/** 专家产业类型 */
export const expertIndustryType = [
    { label: "新一代信息技术", en: "New generation information technology", value: "0" },
    { label: "集成电路", en: "Integrated circuit", value: "1" },
    { label: "医药健康", en: "Medical health", value: "2" },
    { label: "智能装备", en: "Intelligent equipment", value: "3" },
    { label: "节能环保", en: "Energy saving and environmental protection", value: "4" },
    { label: "新能源汽车", en: "New energy vehicle", value: "5" },
    { label: "新材料", en: "New material", value: "6" },
    { label: "人工智能", en: "artificial intelligence", value: "7" },
    { label: "软件和信息服务", en: "Software and information services", value: "8" },
    { label: "科技服务", en: "Technology services", value: "9" },
]

const menu = target => {
    target.getItem = function (value) {
        return this.find(val => val.value == value) || {}
    }
    target.getItemByLabel = function (label) {
        return this.find(val => val.label == label) || {}
    }
    return target;
}

export function findItem(arr = [], value) {
    return arr.find(item => item.value === value) || {};
}

export const inventionOrgType = [
    { label: "科研院所", en: "Scientific research institutes", value: 1 },
    { label: "大专院校", en: "Institutions of higher education", value: 2 },
    { label: "开放实验室", en: "Open laboratory", value: 12 },
    { label: "企业中心", en: "Enterprise Center", value: 8 },
    { label: "其他", en: "Others", value: 7 },
]

// 推介机构类型
// 0 全国学会 1 北京学会 2 行业组织 3 国际平台 4 服务平台 5 政府部门
export const promotionOrgType = [
    { label: "全国学会", en: "Whole country society", value: 0, code: "QGXH" },
    { label: "北京学会", en: "Beijing society", value: 1, code: "BJXH" },
    { label: "行业组织", en: "Industry associations", value: 2, code: "HYZZ" },
    { label: "国际平台", en: "International platform", value: 3, code: "GJPT" },
    { label: "科技园区", en: "Science and Technology Park", value: 7, code: "KJYQ" },
    { label: "其他", en: "Others", value: 6, code: "QTJG" },
]

// 专家
export const replyType = [
    { label: "战略专家", en: "Strategy experts", value: "zj-scope-1" },
    { label: "技术专家", en: "Technical experts", value: "zj-scope-2" },
    { label: "评价专家", en: "Evaluation experts", value: "zj-scope-3" },
    { label: "投资专家", en: "Investment experts", value: "zj-scope-4" },
    { label: "其他专家", en: "Other experts", value: "zj-scope-5" },
]

export const platform = [
    { label: "天合平台", value: "THTT" },
    { label: "海智", value: "HZ" }
]
export const platformDic = {
    THTT: { label: "天合平台", value: "THTT" },
    HZ: { label: "海智", value: "HZ" }
}

export const videoScope = [
    { label: "节能环保", value: "0" },
    { label: "信息技术", value: "1" },
    { label: "先进制造", value: "2" },
    { label: "新型材料", value: "3" },
    { label: "现代农业", value: "4" },
    { label: "生物医药", value: "5" },
]

/** 需求类型 */
export const demandType = [
    { label: "技术难点攻关", value: 1 },
    { label: "技术专家推荐", value: 2 },
    { label: "技术机构合作", value: 3 },
    { label: "企业产品推广", value: 4 },
    { label: "企业转型升级", value: 5 },
    { label: "企业融资上市", value: 6 },
]
export const assets = [{ label: "国有", en: "State-owned", value: 1 }, { label: "民营", en: "Private", value: 2 }];
export const capital = [{ label: "上市", en: "List", value: 1 }, { label: "普通", en: "Ordinary", value: 2 }];
export const technology = [{ label: "高新", en: "High-tech", value: 1 }, { label: "传统", en: "Tradition", value: 2 }];
export const business = [{ label: "制造", en: "", value: 1 }, { label: "服务", en: "", value: 2 }];

/** 成果转化类型 */
export const conversionType = [
    { label: "专利成果转移转化", en: "Transfer and transformation of patent achievements", value: 1 },
    { label: "前沿技术项目合作", en: "Cooperation of cutting-edge technology projects", value: 2 },
    { label: "企业项目合作研发", en: "Cooperative R&D of enterprise projects", value: 3 },
    { label: "成果项目招商落地", en: "Investment promotion and implementation of achievement projects", value: 4 },
    { label: "共建企业创新中心", en: "Joint construction of enterprise innovation center", value: 5 },
    { label: "共建地区产业平台", en: "Joint construction of regional industrial platform", value: 6 },
    { label: "科技专家技术咨询", en: "Technical consultation with science and technology experts", value: 7 },
]
// 需求对接类型
export const dockingType = [
    { label: "专利成果引进转化", en: "Introduction and transformation of patent achievements", value: 1 },
    { label: "前沿技术战略储备", en: "Strategic reserve of cutting-edge technology", value: 2 },
    { label: "企业难题技术攻关", en: "Solve enterprise problems with technological breakthrough", value: 3 },
    { label: "企业产品升级推广", en: "Upgrading and promotion of enterprise products", value: 4 },
    { label: "共建企业创新中心", en: "Joint construction of enterprise innovation center", value: 5 },
    { label: "传统产业系统升级", en: "Upgrading of traditional industrial system", value: 6 },
    { label: "科技专家技术咨询", en: "Technical consultation with science and technology experts", value: 7 },
]
export const projectScope = menu([
    { label: "技术需求精准对接", value: "xm-scope-1" },
    { label: "骨干企业两聚三精", value: "xm-scope-2" },
    { label: "地区产业协同创新", value: "xm-scope-3" },
    // { label: "产品推广项目", value: "xm-scope-4" },
])
export const projectProcess = menu([
    { value: "a", label: "过滤筛选" },
    { value: "b", label: "尽职调查" },
    { value: "c", label: "供需撮合" },
    { value: "d", label: "意向协议" },
    { value: "e", label: "专业评价" },
    { value: "f", label: "方案策划" },
    { value: "g", label: "项目签约" },
    { value: "h", label: "落地实施" },
])

export const orgType = [
    { label: "科研院所", en: "Scientific research institutes", value: 1 },
    { label: "大专院校", en: "Institutions of higher education", value: 2 },
    { label: "企业集团", en: "Enterprise groups", value: 3 },
    { label: "行业组织", en: "Industry associations", value: 4 },
    { label: "学会组织", en: "Society associations", value: 5 },
    { label: "产业组织", en: "Industrial associations", value: 6 },
    { label: "企业中心", en: "Enterprise center", value: 8 },
    { label: "国际机构", en: "International agencies", value: 9 },
    { label: "专业机构", en: "Professional agencies", value: 10 },
    { label: "个人发明", en: "Personal inventions", value: 11 },
    { label: "其他", en: "Others", value: 7 },
]

export const orgLevel = [
    { label: "国际先进", en: "International advanced", value: 0 },
    { label: "国家重点", en: "National priorities", value: 1 },
    { label: "领域一流", en: "First class in the field", value: 2 },
    { label: "其他", en: "Others", value: 3 },
]

export const demandSource = [
    { label: "两聚三精调研", value: 0 },
    { label: "企业体检登记", value: 1 },
    // 外部用户发布时默认为 2
    // { label: "云工坊发布", value: 2 },
    { label: "政府部门征集", value: 3 },
    { label: "地区产业升级", value: 4 },
    { label: "企业直接委托", value: 5 },
    { label: "其他", value: 6 },
]

export const level = [
    { label: "信息平台推广级", value: 0 },
    { label: "转化促进服务级", value: 1 },
]

/** 经济圈 */
export const economicCircle = [
    { label: "京津冀", en: "Beijing-Tianjin-Hebei", value: 1 },
    { label: "长三角", en: "Yangtze River Delta", value: 2 },
    { label: "粤港澳", en: "Guangdong-Hong Kong-Macao", value: 3 },
    { label: "国际", en: "International", value: 4 },
]

/** 诊所阶段 */
export const clinicStage = [
    { label: "体检登记", value: 1 },
    { label: "专业评估", value: 2 },
    { label: "专家沟通", value: 3 },
    { label: "会诊安排", value: 4 },
    { label: "行动方案设计", value: 5 },
    { label: "一对一专家咨询", value: 6 },
    { label: "体检申请受理", value: 7 },
]

/** 单位规模 */
export const companyScale = [
    { label: "超", en: "super", value: "1" },
    { label: "大", en: "large", value: "2" },
    { label: "中", en: "secondary", value: "3" },
    { label: "小", en: "small", value: "4" },
    { label: "微", en: "tiny", value: "5" },
]

/** 团队规模 */
export const teamScale = [
    { label: "超", value: "1" },
    { label: "大", value: "2" },
    { label: "中", value: "3" },
    { label: "小", value: "4" },
]

/** 知识产权状况 */
export const intellectualProperty = [
    { label: "技术秘密", value: 0 },
    { label: "专利", value: 1 },
    { label: "计算机软件", value: 2 },
    { label: "植物新品种", value: 3 },
    { label: "集成电路布图设计", value: 4 },
    { label: "生物、医药新品种（新药证书/临床批件/生产批件）", value: 5 },
    { label: "未涉及知识产权", value: 6 },
]

/** 成果权属 */
export const ownership = [
    { label: "独占", value: 0 },
    { label: "共有", value: 1 },
    { label: "其他", value: 2 },
]

/** 成果阶段 */
export const resultProcess = [
    { value: 1, label: "研制" },
    { value: 2, label: "试生产" },
    { value: 3, label: "小批量生产" },
    { value: 4, label: "批量生产" },
    { value: 5, label: "其他" },
]

/** 合作方式 */
export const cooperation = [
    { label: "股权投资", value: "0" },
    { label: "技术转让", value: "1" },
    { label: "许可使用", value: "2" },
    { label: "合作开发", value: "3" },
    { label: "合作兴办新企业", value: "4" },
    { label: "其他", value: "5" },
]

/** 发布有效期 */
export const resultTerm = [
    { label: "三个月", value: 0 },
    { label: "六个月", value: 1 },
    { label: "一年", value: 2 },
    { label: "其他", value: 3 },
]

/** 天合成果推广模式 */
export const resultExtensionMode = [
    { label: "成果评价", value: 0 },
    { label: "数字展台", value: 1 },
    { label: "成果手册", value: 2 },
    { label: "成果汇编", value: 3 },
    { label: "成果推介会", value: 4 },
    { label: "定向定制科技成果洽谈会", value: 5 },
    { label: "企业联创中心", value: 6 },
    { label: "成果银行", value: 7 },
    { label: "成果落地", value: 8 },
]